import SectionBody from '../components/SectionBody';
import SectionContainer from '../components/SectionContainer';
import SectionTitle from '../components/SectionTitle';

export default function Travel() {
  return (
    <SectionContainer containerId={'travel'}>
      <SectionTitle title={'travel'} />
      <SectionBody>
        <p className='section-text tracking-widest font-semibold'>
          Leaving from Boston, Massachusetts
        </p>
        <p className='section-text'>
          Boothbay Harbor is about 3 hours north of Boston by car. Follow I-95
          North through Portsmouth, New Hampshire up to Portland, Maine. Toll
          roads in New Hampshire and Maine on I-95.
        </p>

        <p className='section-text tracking-widest font-semibold'>
          Leaving from Portland, Maine
        </p>
        <p className='section-text'>
          Follow I-295 North to Brunswick, Maine. Take Exit 28 to Maine Route 1
          North through Brunswick, Bath, and Wiscasset. About a mile after the
          Wiscasset bridge, make a right on Maine Route 27 South towards
          Boothbay Harbor.
        </p>

        <p className='section-text tracking-widest font-semibold'>Parking</p>
        <p className='section-text'>
          Parking at the venue is very limited, so please walk if you are able.
          There are several parking lots nearby that are about a 10 minute walk
          to the venue, but please reach out to me (Robbie) if you have any
          concerns.
        </p>
      </SectionBody>
    </SectionContainer>
  );
}
